import React, {
  Fragment as _,
  createContext,
  useState,
  useContext,
} from 'react';
import { Box } from 'theme-ui';

const AssessmentQuestionOptions = ({ children, ...props }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
      }}
    >
      {[...children].map((child, index) => {
        return React.cloneElement(child, {
          numOptions: children.length,
          index,
        });
      })}
    </Box>
  );
};

export default AssessmentQuestionOptions;
